var map = {
	"./Combined Shape.svg": 637,
	"./HUN_bekescsaba_cimer.svg": 638,
	"./bekescsaba_marker.svg": 341,
	"./close.svg": 639,
	"./data_light_logo.svg": 417,
	"./data_light_logo_test.svg": 342,
	"./header_dashboard_logo.svg": 640,
	"./icon_24.png": 641,
	"./interface-right-side.png": 352,
	"./interface_left_data.png": 353,
	"./ize.png": 642,
	"./ize.svg": 643,
	"./lights.svg": 644,
	"./manageyourcity.svg": 645,
	"./menu_bottom_logo.png": 646,
	"./menu_bottom_logo.svg": 419,
	"./pm.png": 647,
	"./pm.svg": 648,
	"./pm_aff.svg": 649,
	"./polygonal-mosaic-background.png": 650,
	"./rect.svg": 651,
	"./search.svg": 652,
	"./smart-ready.svg": 653,
	"./smart.svg": 654,
	"./street-lamp.png": 655,
	"./testitemimage.png": 656,
	"./toggle.svg": 657,
	"./totem.svg": 658,
	"./ums.svg": 659,
	"./utu_blue.svg": 222,
	"./utu_dark.svg": 660,
	"./utu_light.png": 661,
	"./utu_light.svg": 662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 418;